import {TicketFormField} from "./TicketFormField";
import {UiRadioList} from "./components/UiRadioList";
import {RadioList} from "./RadioList";
import {Arrays} from "./Utils";

export class TicketTypeFormField extends TicketFormField {
	afterIndex() {
		super.afterIndex();
		const inp = this.container.querySelector('input');
		let initValue: string|null = "";
		if (inp) {
			const onChange = (v: string | null) => {
				this.updateFields(v);
			}
			if (inp.tagName === "SELECT") {
				inp.addEventListener('change', ev => onChange(inp.value));
				initValue = inp.value;
			} else {
				const radioList = new RadioList(inp);
				radioList.onChange = v => onChange(v);
				initValue = radioList.value;
			}
			this.muParent.muOnAfterIndex.push(() => onChange(initValue));
		}
	}

	updateFields(v: string|number|null) {
		v = typeof v === "string" ? parseInt(v) : v;
		let all: string[] = [];
		let visible: string[] = [];
		for(const rule of this.visibilityFieldsRules) {
			all = [...all, ...rule.fields];
			if (rule.values.includes(v || -1)) visible = [...visible, ...rule.fields ];
		}
		all = Array.from(new Set(all));
		visible = Array.from(new Set(visible));

		const hide = Arrays.diff(all, visible);
		this.muParent.muVisible(false, hide);
		this.muParent.muVisible(true, visible);
	}

	public visibilityFieldsRules: { "values":number[], "fields": string[]}[] = [];

}